export const deClientPortalThreadOverviewPagePages = {
    threadOverviewPage: {
        title: 'Unterhaltungen',
        filters: {
            noResults: 'Keine Unterhaltungen zu diesem Auftrag gefunden',
        },
        selection: {
            newConversation: 'Neue Unterhaltung',
            item: {
                noTitle: 'Kein Titel',
                notifiedUsersTooltip:
                    'Über neue Nachrichten wird aktuell niemand benachrichtigt. Hier klicken, um Benachrichtigte hinzuzufügen.',
                options: 'Optionen',
                unpin: 'Unterhaltung abpinnen',
                pin: 'Unterhaltung pinnen',
                delete: 'Unterhaltung löschen',
            },
        },
        createDialog: {
            title: 'Neue Unterhaltung',
            create: 'Erstellen',
            cancel: 'Abbrechen',
            topicLabel: 'Titel *',
            participantsLabel: 'Weitere Benachrichtigte hinzufügen...',
            defaultNotifiedUsers: 'Standard-Benachrichtigte dieser neuen Unterhaltung:',
            yourself: 'Sie selbst',
            creator: 'Ersteller/in',
            observers: 'Beobachter/innen',
            assignees: 'Zuständige',
            observersDescriptionSuffix: 'des Auftrags, inkl.',
        },
        emptyState: {
            loadingTitle: 'Unterhaltungen werden geladen...',
            emptyTitle: 'Keine offenen Unterhaltungen vorhanden',
            emptyDescriptionLineOne: 'Starten Sie eine neue Unterhaltung, um Fragen zu stellen, Unterstützung',
            emptyDescriptionLineTwo: 'zu erhalten oder Informationen mit anderen Nutzern auszutauschen.',
            newConversation: 'Neue Unterhaltung',
        },
        orderDropdown: {
            loading: 'Lade Auftragsdaten...',
            label: 'Auftrag',
            noOptions: 'Keine Aufträge gefunden',
            valuationDate: 'Stichtag',
            orderDate: 'Auftragsdatum',
        },
        thread: {
            noMessages: 'Keine Nachrichten',
            deletedMessage: 'Nachricht wurde gelöscht',
            createdBy: 'Unterhaltung wurde von {{userName}} angelegt',
            createdAutomatically: 'Die Unterhaltung wurde automatisch angelegt',
        },
    },
}
